<div class="container1">
  <div class="modal-header" >
    <span style="color:#fff !important;"> {{this.source[this.hopIndex].source}}<i class="fa fa-arrow-right"
    style="color:#fff !important;margin-left:6px;margin-right:6px;"></i> {{this.source[this.hopIndex].dest}}</span>
    <button type="button" class="close" data-dismiss="modal" (click)="onModelCancel()">
      <i attr.data-track="seatSelectionCancelled" class="material-icons" style="color:#fff;">close</i>
    </button>
  </div>
  @if (this.showSeats) {
    <div class="modal-body">
      <div class="row">
        <div class="col-2 d-none d-md-block">
        </div>
        <div class="col-12 col-lg-12">
          <div class="seat-row-internal" style="margin-bottom:20px;">
            <div class="col-auto" style="width:50px !important;text-align: center;">
              <i class="fa fa-square-o item" aria-hidden="true"></i>
              <label class="name">{{'seat.OPEN' | translate}}</label>
            </div>
            <div class="col-auto" style="width:50px !important;text-align: center;">
              <i class="fa fa-square-o item6" aria-hidden="true"></i><img class="{{isMobile? 'shape2':'shape'}}"
              src="assets/images/Shape 2.svg">
              <label class="name"> {{'seat.TAKEN' | translate}}</label>
            </div>
            <div class="col-auto" style="width:70px !important;text-align: center;">
              <i class="fa fa-square-o item5" aria-hidden="true"></i>
              <label class="name"> {{'seat.SELECTED' | translate}}</label>
            </div>
            <div class="col-auto" style="width:70px !important;text-align: center;">
              <i class="fa fa-square-o item1" aria-hidden="true"></i>
              <label class="name"> {{'seat.PREMIUM' | translate}}</label>
            </div>
            <div class="col-auto" style="width:50px !important;text-align: center;">
              <i class="fa fa-square-o item2" aria-hidden="true"></i>
              <label class="name"> {{'seat.EXIT' | translate}}</label>
            </div>
            <div class="col-auto" style="width:50px !important;text-align: center;">
              <i class="fa fa-square-o item3" aria-hidden="true"></i>
              <label class="name">{{'seat.WINGS' | translate}}</label>
            </div>
          </div>
          <hr>
            @if (this.seatData) {
              <div>
                @for (item of this.seatData[this.index]; track item; let i = $index) {
                  <div
                    class="{{item.characteristic && haveExitRow(item.characteristic) ? 'filter-row2':'filter-row1'}}">
                    @if (item.characteristic && !haveWings(item.characteristic)) {
                      <div class="wingsNotPresent">
                      </div>
                    }
                    @if (item.characteristic && haveWings(item.characteristic)) {
                      <div class="wingsPresent">
                        <i class="fa fa-square-o item4" aria-hidden="true"></i>
                      </div>
                    }
                    <label class="rowNo">{{item.rowCode}}</label>
                    <div class="seat-row-internal">
                      @for (seat of item.row; track seat; let j = $index) {
                        <div>
                          @if (seat.type==='Seat' && seat.available==='BLOCKED') {
                            <div class="col-auto">
                              <i class="fa fa-square-o item6" aria-hidden="true"></i><img class="shape"
                              src="assets/images/Shape 2.svg">
                            </div>
                          }
                          @if (seat.type==='Seat' && seat.available==='OCCUPIED') {
                            <div class="col-auto">
                              <i class="fa fa-square-o item6" aria-hidden="true"></i><img class="shape"
                              src="assets/images/Shape 2.svg">
                            </div>
                          }
                          @if (seat.type==='Seat' && seat.available==='RESERVED') {
                            <div class="col-auto">
                              <i class="fa fa-square-o item6" aria-hidden="true"></i><img class="shape"
                              src="assets/images/Shape 2.svg">
                            </div>
                          }
                          @if (seat.type==='Seat' && seat.available==='NO_SEAT') {
                            <div class="col-auto">
                              <i class="fa fa-square-o item6" aria-hidden="true"></i><img class="shape"
                              src="assets/images/Shape 2.svg">
                            </div>
                          }
                          @if (seat.type==='Seat' && seat.available===null) {
                            <div class="col-auto">
                              <i class="fa fa-square-o item6" aria-hidden="true"></i><img class="shape"
                              src="assets/images/Shape 2.svg">
                            </div>
                          }
                          @if (seat.type==='Seat' && seat.available==='AVAILABLE'&& getSeatSelected(seat.seatCode)===undefined) {
                            <div
                              class="col-auto">
                              <i class="fa fa-square-o item" aria-hidden="true" (click)="selectSeat(seat.seatCode)"></i>
                            </div>
                          }
                          @if (seat.type==='Seat' && seat.available==='Premium' && getSeatSelected(seat.seatCode)===undefined) {
                            <div
                              class="col-auto">
                              <i class="fa fa-square-o item1" aria-hidden="true" (click)="selectSeat(seat.seatCode)"></i>
                            </div>
                          }
                          @if (getSeatSelected(seat.seatCode)===seat.seatCode) {
                            <div class="col-auto">
                              <i class="fa fa-square-o item5" aria-hidden="true" (click)="selectSeat(seat.seatCode)"></i><span
                            class="name1" (click)="selectSeat(seat.seatCode)">{{getSeatCodeToDisplay(seat.seatCode)}}</span>
                          </div>
                        }
                        @if (seat.type==='Aisle') {
                          <div class="col-auto" style="width:21px;">
                          </div>
                        }
                      </div>
                    }
                  </div>
                  @if (item.characteristic && !haveWings(item.characteristic)) {
                    <div class="wingsNotPresent1">
                    </div>
                  }
                  @if (item.characteristic && haveWings(item.characteristic)) {
                    <div class="wingsPresent1">
                      <i class="fa fa-square-o item4" aria-hidden="true"></i>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        <div class="col-2 d-none d-md-block">
        </div>
      </div>
      @if ((this.seatData && this.seatData.length >0)&& this.totalFreeSeat) {
        <div style="margin-top:40px;">
          <div class="text-center" style="margin-bottom:50px !important;margin-left:0px;">
            @if (this.index > 0) {
              <button class="btn btn-secondary2" style="margin-right:10px !important;"
                (click)="selectIndexDecrease()"><span class="add2"> {{'seat.back' | translate}}</span></button>
              }
              @if (this.hopIndex !== (this.source.length -1)) {
                <button class="btn btn-secondary1" (click)="selectIndex()"
                  [disabled]="(this.selectedSeatArray[this.index].length !== this.bookingService.travellers && this.selectedSeatArray[this.index].length < this.totalFreeSeat[index])"><span
                class="add2">{{'seat.Next' | translate}}:{{'seat.Selectseatsfor' | translate}} {{getSourceName()}} -> {{getDestName()}}</span></button>
              }
              @if ((this.selectedSeatArray[this.index].length !== this.bookingService.travellers && this.selectedSeatArray[this.index].length < this.totalFreeSeat[index]) && (this.hopIndex !== (this.source.length -1))) {
                <button
                  class="btn btn-secondary2" style="margin-right:6px;margin-left:6px;width:70px !important;"
                  (click)="selectSkip()"><span class="add2">{{'seat.skip' | translate}}</span></button>
                }
                <!-- <button  *ngIf="this.source.length > (this.seatData.length -1)" class="btn btn-secondary1" (click)="selectIndex()"><span class="add2">next</span></button>
                --> @if (this.hopIndex === (this.source.length -1)) {
                <button class="btn btn-secondary"
                  attr.data-track="seatSelectionDone" (click)="proceedForPayment()"><span class="add"
                  attr.data-track="seatSelectionDone">@if ((this.selectedSeatArray[this.index].length !== this.bookingService.travellers && this.selectedSeatArray[this.index].length < this.totalFreeSeat[index])) {
                  <span
                    >skip
                  & </span>
                  }{{'seat.PROCEEDTOPAY' | translate}}: {{this.bookingService.total | currency : getCurrencySymbol(this.bookingService.currencyCode) : "code"
                : '1.2-2' }}</span></button>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (!this.showSeats) {
      <div class="modal-body">
        <div class="text-center" style="margin-bottom:40px !important;margin-top:40px !important;"> {{'seat.Nofreeseatsavailable' | translate}} </div>
        <div class="text-center" style="margin-bottom:50px !important;">
          @if (this.hopIndex > 0) {
            <button class="btn btn-secondary1" style="margin-right:10px !important;"
              (click)="selectIndexDecrease()"><span class="add2">{{'seat.back' | translate}</span></button>
            }
            @if (this.hopIndex !== (this.source.length -1)) {
              <button class="btn btn-secondary1"
                (click)="selectIndexForSeat()"><span class="add2">{{'seat.Next' | translate}}: {{'seat.Selectseatsfor' | translate}} {{this.source[this.hopIndex].source}}
              -> {{this.source[this.hopIndex].dest}}</span></button>
            }
            @if (this.hopIndex === (this.source.length -1)) {
              <button class="btn btn-secondary"
                (click)="proceedForPayment()"><span class="add">{{'seat.PROCEEDTOPAY' | translate}}</span></button>
              }
            </div>
          </div>
        }

      </div>